import React from 'react'
import PropTypes from 'prop-types'
import parser from 'cron-parser'
import cronstrue from 'cronstrue'
import moment from 'moment'
import { Selector } from '@leverege/ui-elements';
import { TextInput, Flex, LabelGroup, Section } from '~/views';
import BaseTimerEditor from './BaseTimerEditor'

import { TimerActionFactory } from '../timerAction'
import style from './style.css'

export default class ScheduledTimerEditor extends React.Component {
  static propTypes = {
    timer : PropTypes.object,
    currentContext : PropTypes.object,
    onChange : PropTypes.func.isRequired
  }

  static TYPE = 'scheduled'

  static DEFAULTS = {
    type : 'scheduled',
    cron : '0 0 0 * * *',
    timezone : 'UTC'
  }

  onChangeCron = ( cron, err ) => {
    let parseErr
    try {
      parser.parseExpression( cron )

    } catch ( ex ) {
      ex.message = 'invalid cron string'
      parseErr = ex
    }
    this.baseTimer.changePath( 'timer/cron', cron, parseErr )
  }

  validateCron = ( cron, err ) => {
    let parseErr
    try {
      parser.parseExpression( cron )

    } catch ( ex ) {
      ex.message = 'invalid cron string'
      parseErr = ex
    }
    
    return parseErr == null
  }

  changePath = ( path, value, err ) => {
    console.log( path, value, err )
    if ( err ) {
      console.log( `error setting ${key} to ${value}` )
      return
    }
    if ( typeof this.props.onChange === 'function' ) {
      this.props.onChange( { target : this.props.timer, path, value } );
    }
  }

  render() {
    const { timer, currentContext } = this.props
    const timerObj = timer.timer
    return (
      <div className={style.container}>
        <BaseTimerEditor ref={ref => this.baseTimer = ref} {...this.props} />
        <Section title="Timer">
          <Flex variant="vSpace" align="stretch" direction="column">
            {BaseTimerEditor.getDisplayTypeDropdown( timerObj, this.changePath )}
            <LabelGroup>
              <label>Cron String</label>
              <TextInput
                value={timerObj.cron}
                changeOnReturn
                size={10}
                onChange={this.onChangeCron}
                validator={this.validateCron} />
            </LabelGroup>
            <LabelGroup>
              <label />
              <label>
                { cronstrue.toString( timerObj.cron ).trim() }
              </label>
            </LabelGroup>
            <LabelGroup>
              <label>Timezone</label>
              <Selector
                values={moment.tz.names().map( tzName => ( { name : tzName, value : tzName } ) )}
                value={timerObj.timezone}
                onChange={( { value } ) => { this.baseTimer.changePath( 'timer/timezone', value, false ) }} />
            </LabelGroup>
          </Flex>
        </Section>
        { TimerActionFactory.createEditor( timer.action, { ...this.props } ) }
        { BaseTimerEditor.getDisplayContext( timer, currentContext ) }
      </div>
    )
  }

}
